import { render, staticRenderFns } from "./degreeInjury.vue?vue&type=template&id=23d1768e&scoped=true"
import script from "./degreeInjury.vue?vue&type=script&lang=js"
export * from "./degreeInjury.vue?vue&type=script&lang=js"
import style0 from "./degreeInjury.vue?vue&type=style&index=0&id=23d1768e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d1768e",
  null
  
)

export default component.exports